// import axios from "axios";

// // export function postRequest(url, headerToken, subscriptionKey,body) {
// //     const config = {
// //       headers: {
// //         Authorization: `Bearer ${headerToken}`,
// //         "Ocp-Apim-Subscription-Key": subscriptionKey,
// //         "Content-type": "application/json",
// //       },
// //     };
// //     const data = (axios.post(url,body,config))
// //   return data;
// // }
// export function postRequest(url, body) {
//   const config = {
//     headers: {
//       'Access-Control-Allow-Origin': true,
//     },
//   };
//   const data = axios.post(url, body, config);
//   return data;
// // }

// import axios from "axios";
// import CryptoJS from "crypto-js";
// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// export function postRequest(url, headerToken, subscriptionKey,body) {
//     const config = {
//       headers: {
//         Authorization: `Bearer ${headerToken}`,
//         "Ocp-Apim-Subscription-Key": subscriptionKey,
//         "Content-type": "application/json",
//       },
//     };
//     const data = (axios.post(url,body,config))
//   return data;
// }

// const encryptPayload = (data) => {
//   const ciphertext = CryptoJS.AES.encrypt(
//     JSON.stringify(data),
//     SECRET_KEY
//   ).toString();
//   return ciphertext;
// };

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   try {
//     let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//     let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     // console.log("hello data ", decryptedData)
//     return decryptedData;
//   } catch (e) {
//     return ciphertext;
//   }
// }

// export async function postRequest(url, body) {
//   const config = {
//     headers: {
//       "Access-Control-Allow-Origin": true,
//     },
//   };
//   const payload = encryptPayload(body);
//   //const payload = body;
//   // console.log("payload", payload);
//   const data = await axios.post(url, payload, config);
//   // console.log(data);
//   const decryptFunctionData = decryptFunction(data.data, SECRET_KEY);
//   // console.log(decryptFunctionData);
//   return decryptFunctionData;
// }

import axios from "axios";
import CryptoJS from "crypto-js";
import { handleLogout } from "./getRequest";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

/* ================= ENCRYPT ================= */
const encryptPayload = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
};

/* ================= DECRYPT ================= */
const decryptFunction = (ciphertext) => {

  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.error("Decryption failed:", e);
    return ciphertext;
  }
};

/* ================= POST REQUEST ================= */
export async function postRequest(url, body) {
  const authToken = localStorage.getItem("authToken");

  const config = {
    headers: {
      "Content-Type": "text/plain",
      Authorization: authToken ? `Bearer ${authToken}` : "",
    },
  };



  // 🔐 Encrypt request body
  const encryptedPayload = encryptPayload(body);
  // const encryptedPayload = body;


  try {
    const response = await axios.post(url, encryptedPayload, config);

    // 🔓 Decrypt response from backend
    const decryptedData = decryptFunction(response.data);
   

    return decryptedData;
  } catch (error) {
    if (error?.response?.status === 401) {
      handleLogout();
      return;
    }
    throw error;
  }
}